import {KTCard} from '../../../../_metronic/helpers'
import {CategoriesTable} from './CategoriesTable'

const ClassifiedCategoriesList = () => {
  return (
    <>
      <KTCard>
        <CategoriesTable />
      </KTCard>
    </>
  )
}

const ClassifiedCategoriesListWrapper = () => <ClassifiedCategoriesList />

export {ClassifiedCategoriesListWrapper}
